import { render, staticRenderFns } from "./AppointmentPay.vue?vue&type=template&id=c70f8710"
import script from "./AppointmentPay.vue?vue&type=script&lang=js"
export * from "./AppointmentPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports